export default {"src":"/_next/static/media/managed-wordpress.927bf545.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};